/* global require */
import 'react-hot-loader/patch';
import { AppContainer } from 'react-hot-loader';
import assetBase from './utils/publicPath';
require('../../common/styles/_common.scss');
require('../../adminxOnboard/styles/AdminxOnboarding.scss');
import React from 'react';
import ReactDOM from 'react-dom';
import { MsalProvider } from '@azure/msal-react';
import { Provider } from 'react-redux';
import store from '../../store';
import { PublicClientApplication } from '@azure/msal-browser';
import storage from 'local-storage-fallback';
import Config from './utils/Config';
import FT, { init as initLD } from './utils/FeatureToggles';
import { msalConfig } from './utils/msalConfig';
import AdminxOnboard from '../../adminxOnboard/js/containers/AdminxOnboard';
import { getAdminxOnboardingStyle } from './utils/adminx_onboarding_style';
import Debug from './utils/Debug';
if (!window.Promise) {
  window.Promise = Promise;
}

try {
  if (!window.localStorage) {
    throw 'Local storage not defined!';
  }
} catch (e) {
  window.localStorage = storage;
}

const render = (AdminxOnboard) => {
  Config.load(assetBase + 'config.json').then(() => {
    let _render = () => {
      const theme = Config.get('theme') ? Config.get('theme') : { mode: 'light', selectedColor: 'default' };
      const AdminxOnboardingStyle = getAdminxOnboardingStyle(theme.mode, theme.selectedColor);
      const msalInstanceConfig = () => {
        let msalConfigObj = msalConfig;
        msalConfigObj.auth.clientId = Config.get('azure_ad_client_id');
        msalConfigObj.auth.redirectUri = window.location.origin;
        if (localStorage && localStorage.getItem('override__azure_ad_redirect_url')) {
          msalConfigObj.auth.redirectUri = localStorage.getItem('override__azure_ad_redirect_url');
        }
        if (localStorage && localStorage.getItem('override__azure_ad_client_id')) {
          msalConfigObj.auth.clientId = localStorage.getItem('override__azure_ad_client_id');
        }
        return msalConfigObj;
      };
      const msalInstance = new PublicClientApplication(msalInstanceConfig());

      ReactDOM.render(
        <AppContainer>
          <MsalProvider instance={msalInstance}>
            <Provider store={store}>
              <div className='dui'>
                <AdminxOnboardingStyle>
                  <div className='container' id='adminx_onboarding'>
                    <AdminxOnboard configUrl={assetBase + 'config.json'} />
                  </div>
                </AdminxOnboardingStyle>
              </div>
            </Provider>
          </MsalProvider>
        </AppContainer>,
        document.getElementById('dui-app-container'),
      );
    };
    initLD()
      .then(() => {
        _render();
      })
      .catch(() => {
        Debug.log('Error initializing LaunchDarkly');
        _render();
      });
  });
};
render(AdminxOnboard);

window.DaasUi = window.DaasUi ? window.DaasUi : {};
window.DaasUi.FT = FT;
// Hot Module Replacement API
if (module.hot) {
  module.hot.accept('../../adminxOnboard/js/containers/AdminxOnboard', () => {
    render(AdminxOnboard);
  });
}
